import Page from '@/gf/components/Page'
import Transactions from '@/gf/components/Transactions'

import useSession from '../hooks/useSession'
import UserContext from '@/gf/modules/User'

import Frame from '../components/Frame'

const breadcrumbs = {
  copy: 'Back to Dashboard',
  crumbs: [{ name: 'Transactions', href: '/Transactions' }],
}

const TransactionsPage = () => {
  const { store, user } = useSession()

  return (
    <Frame breadcrumbs={breadcrumbs}>
      <Page
        title="Transactions"
        titleRightContent={
          UserContext.isAdmin(user) ? undefined : (
            <div>
              <a
                href={`/exports/transactions?store_id=${store.id}`}
                className="text-white border-transparent bg-gearflow hover:bg-yellow-700 focus:ring-yellow-500 px-4 py-2 border text-sm rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
              >
                Export
              </a>
            </div>
          )
        }
      >
        <Transactions />
      </Page>
    </Frame>
  )
}

export default TransactionsPage
